'use client';

import Link from 'next/link';
import Image from 'next/image';
import { useEffect } from 'react';
import Header from '@layout/HeaderClient';
import Footer from '@layout/Footer';
import { ArrowUpRight, Home, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function Error({ error, reset }) {
  useEffect(() => {
    fetch('/api/log-error', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({
        message: error?.message || 'Unknown client error',
        digest:  error?.digest  || null,
        url:     window.location.pathname,
        category: 'FRONTEND',
      }),
    }).catch(() => {});
  }, [error]);

  return (
    <div className="min-h-full flex flex-col">
      <Header />
      <main className="flex-1 flex items-center justify-center pb-20 pt-40">
        <div className="max-w-lg w-full text-center relative">
          <Image
            src="/images/404-Error.svg"
            alt="404 Error Page"
            width={320}
            height={240}
            loading='eager'
            className="mx-auto"
          />
          <p className="text-6xl font-bold text-secondary/10 leading-none select-none absolute top-2 left-50">500</p>
          <h1 className="text-3xl font-bold text-secondary mb-3">Something Went Wrong</h1>
          <p className="text-slate-500 mb-8 leading-relaxed">
            We encountered an unexpected error. Our team has been notified.
            Please try again or return to the home page.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Button
              onClick={reset}
              className="bg-red-gradient border-0 btn-glass group h-10 px-5 cursor-pointer"
            >
              <span className="relative z-10 flex items-center gap-2 text-white group-hover:text-secondary transition-colors duration-300">
                <RefreshCw size={15} />
                Try Again
              </span>
            </Button>
            <Button asChild variant="outline" className="h-10 px-5 border-slate-200 text-secondary hover:bg-slate-50 group">
              <Link href="/">
                <Home size={14} className="mr-1.5" />
                Back to Home
                <ArrowUpRight size={14} className="ml-1.5 transition-transform duration-200 group-hover:translate-x-0.5" />
              </Link>
            </Button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
